export const RESET = 'order/RESET';
export const ADD_BARBER = 'order/ADD_BARBER';
export const REMOVE_BARBER = 'order/REMOVE_BARBER';
export const ADD_APPOINTMENT = 'order/ADD_APPOINTMENT';
export const ADD_CHARGE = 'order/ADD_CHARGE';
export const ADD_GIFT_CARD = 'order/ADD_GIFT_CARD';
export const UPDATE_GIFT_CARD = 'order/UPDATE_GIFT_CARD';
export const ADD_ITEM = 'order/ADD_ITEM';
export const REMOVE_ITEM = 'order/REMOVE_ITEM';
export const SET_ITEM_QUANTITY = 'order/SET_ITEM_QUANTITY';
export const ADD_DISCOUNT = 'order/ADD_DISCOUNT';
export const REMOVE_DISCOUNT = 'order/REMOVE_DISCOUNT';
export const POPULATE = 'order/POPULATE';
export const IS_EMPTY = 'order/IS_EMPTY';
export const SET_MEMBERSHIP = 'order/SET_MEMBERSHIP';
export const SET_PRESERVE_ORDER_CUSTOMER = 'order/SET_PRESERVE_ORDER_CUSTOMER';
